var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fa fa-circle",class:_vm.instance.status ? ' text-success' : ' text-danger',attrs:{"title":_vm.instance.status ? 'Ativo' : 'Inativo'}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fa2d2f9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/StatusComponent.vue
// module id = 1067
// module chunks = 1